import { render } from "./EditImageView.vue?vue&type=template&id=201695e4&scoped=true"
import script from "./EditImageView.vue?vue&type=script&lang=js"
export * from "./EditImageView.vue?vue&type=script&lang=js"

import "./EditImageView.vue?vue&type=style&index=0&id=201695e4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201695e4"]])

export default __exports__